const RATERS = {
  ANCAP: 'ANCAP',
  UCSR: 'UCSR',
  NO_RATING: 'Not rated',
  NO_CURRENT_RATING: 'No current rating',
};

export default RATERS;
